<script>
  import { ShieldCheck } from 'lucide-svelte';
  import SettingsCard from './shared/SettingsCard.svelte';
  import SettingField from './shared/SettingField.svelte';

  let minimumPasswordLength = 8;
  let sessionTimeout = 30;
  let requireStrongPassword = true;
  let notifyOnNewDevice = true;

  const inputClass =
    'h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100';
  const checkboxClass = 'h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-2 focus:ring-blue-100';
</script>

<div class="min-h-full bg-slate-100 p-4 lg:p-6">
  <div class="mx-auto max-w-5xl space-y-4">
    <SettingsCard title="Security Policy" description="Password requirements and session controls.">
      <span slot="actions" class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
        <ShieldCheck size={18} />
      </span>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <SettingField id="security-password-length" label="Minimum Password Length">
          <input id="security-password-length" type="number" min="6" max="32" bind:value={minimumPasswordLength} class={inputClass} />
        </SettingField>

        <SettingField id="security-session-timeout" label="Session Timeout" hint="Minutes before an inactive session expires.">
          <input id="security-session-timeout" type="number" min="5" max="240" bind:value={sessionTimeout} class={inputClass} />
        </SettingField>

        <label class="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-700 md:col-span-2">
          Require strong password rules
          <input type="checkbox" bind:checked={requireStrongPassword} class={checkboxClass} />
        </label>

        <label class="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium text-slate-700 md:col-span-2">
          Notify user on new device sign-in
          <input type="checkbox" bind:checked={notifyOnNewDevice} class={checkboxClass} />
        </label>
      </div>
    </SettingsCard>
  </div>
</div>
